<template>
  <div class="d-flex flex-column align-center justify-center">
    <v-progress-circular indeterminate color="lime" size="150" width="20"></v-progress-circular>
    <div class="text-center mt-4">
      <h3 class="font-weight-bold black--text">{{ title }}</h3>
      <p class="black--text font-weight-light">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Loading...",
      description: "처리 중 입니다. 잠시만 기다려주세요.",
    };
  }
};
</script>

<style scoped></style>